<template>
  <div class="card executive-card mb-4">
    <div class="card-header section-header border-0 pt-3 pb-0 px-3 d-flex align-items-center gap-2">
      <div class="title-wrap">
        <vue-feather type="cpu" size="17" class="text-primary" />
        <h5 class="section-title mb-0">Alertas e Oportunidades da Operacao</h5>
      </div>
      <span class="section-badge">Camada IA</span>
    </div>
    <div class="card-body pt-3">
      <div v-if="weatherLoading || weatherInsight" class="row mb-1">
        <div class="col-12">
          <div class="insight-card climate-card" :class="weatherLevelClass">
            <div class="insight-head">
              <div class="insight-icon" :class="weatherIconClass">
                <vue-feather type="cloud-drizzle" size="14" />
              </div>
              <h6>{{ weatherLoading ? 'Carregando recomendacao climatica...' : weatherInsight.title }}</h6>
            </div>
            <p class="mb-0">
              {{
                weatherLoading
                  ? 'Consultando previsao do tempo para recomendacao de aplicacao de defensivos.'
                  : weatherInsight.message
              }}
            </p>
            <div v-if="weatherInsight && weatherInsight.metrics" class="climate-metrics">
              <span>Vento: {{ weatherInsight.metrics.wind || 0 }} km/h</span>
              <span v-if="weatherInsight.metrics.gust">Rajada: {{ weatherInsight.metrics.gust }} km/h</span>
              <span>Chuva: {{ weatherInsight.metrics.rainProb || 0 }}%</span>
              <span>Umidade: {{ weatherInsight.metrics.humidity || 0 }}%</span>
              <span v-if="weatherInsight.metrics.temperature !== null">
                Temp max: {{ weatherInsight.metrics.temperature }}°C
              </span>
              <span v-if="weatherInsight.metrics.minTemperature !== null">
                Temp min: {{ weatherInsight.metrics.minTemperature }}°C
              </span>
              <span v-if="weatherInsight.metrics.uv">
                UV: {{ weatherInsight.metrics.uv }}
              </span>
            </div>
            <small v-if="weatherInsight && weatherInsight.source" class="insight-source">
              Fonte: {{ weatherInsight.source }}
            </small>
            <button
              v-if="weatherInsight && !weatherLoading"
              class="insight-detail-btn"
              type="button"
              @click="openInsightDetail(weatherInsight, 'weather')"
            >
              Ver detalhes
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div v-for="item in insights" :key="item.title" class="col-12 col-lg-4 mb-3">
          <div class="insight-card" :class="`insight-${item.level}`">
            <div class="insight-head">
              <div class="insight-icon" :class="`insight-icon-${item.level}`">
                <vue-feather :type="iconByLevel(item.level)" size="14" />
              </div>
              <h6>{{ item.title }}</h6>
            </div>
            <p class="mb-0">{{ item.message }}</p>
            <small v-if="item.source" class="insight-source">Fonte: {{ item.source }}</small>
            <button class="insight-detail-btn" type="button" @click="openInsightDetail(item, 'insight')">
              Ver detalhes
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="insight-detail-modal"
      ref="detailModal"
      hide-footer
      centered
      modal-class="insight-modal-shell"
      content-class="insight-modal-content"
    >
      <template #modal-header>
        <div class="insight-modal-header">
          <div class="insight-modal-icon" :class="selectedLevelClass">
            <vue-feather :type="selectedIcon" size="16" />
          </div>
          <div>
            <h5 class="mb-0">{{ selectedInsight ? selectedInsight.title : 'Detalhe do Insight' }}</h5>
            <small class="insight-modal-subtitle">Painel executivo de recomendacoes</small>
          </div>
        </div>
      </template>

      <div v-if="selectedInsight" class="insight-modal-body">
        <p class="insight-modal-text mb-2">{{ selectedInsight.message }}</p>
        <small v-if="selectedInsight.source" class="insight-source d-block mb-3">
          Fonte: {{ selectedInsight.source }}
        </small>

        <div v-if="selectedInsight.metrics" class="climate-metrics mb-3">
          <span>Vento: {{ selectedInsight.metrics.wind || 0 }} km/h</span>
          <span v-if="selectedInsight.metrics.gust">Rajada: {{ selectedInsight.metrics.gust }} km/h</span>
          <span>Chuva: {{ selectedInsight.metrics.rainProb || 0 }}%</span>
          <span>Umidade: {{ selectedInsight.metrics.humidity || 0 }}%</span>
          <span v-if="selectedInsight.metrics.temperature !== null">
            Temp max: {{ selectedInsight.metrics.temperature }}°C
          </span>
          <span v-if="selectedInsight.metrics.minTemperature !== null">
            Temp min: {{ selectedInsight.metrics.minTemperature }}°C
          </span>
          <span v-if="selectedInsight.metrics.uv">UV: {{ selectedInsight.metrics.uv }}</span>
        </div>

        <div class="insight-reco-box">
          <h6>Acoes recomendadas</h6>
          <ul>
            <li v-for="(line, index) in selectedRecommendations" :key="`reco-${index}`">{{ line }}</li>
          </ul>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ExecutiveInsightsSection',
  props: {
    insights: {
      type: Array,
      default: () => [],
    },
    weatherInsight: {
      type: Object,
      default: null,
    },
    weatherLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedInsight: null,
      selectedType: 'insight',
      hasAutoOpenedWeatherModal: false,
    }
  },
  watch: {
    weatherInsight: {
      deep: true,
      handler() {
        this.tryAutoOpenWeatherModal()
      },
    },
    weatherLoading() {
      this.tryAutoOpenWeatherModal()
    },
  },
  computed: {
    weatherLevelClass() {
      if (!this.weatherInsight) return 'insight-info'
      return `insight-${this.weatherInsight.level || 'info'}`
    },
    weatherIconClass() {
      if (!this.weatherInsight) return 'insight-icon-info'
      return `insight-icon-${this.weatherInsight.level || 'info'}`
    },
    selectedIcon() {
      if (!this.selectedInsight) return 'activity'
      return this.iconByLevel(this.selectedInsight.level || 'info')
    },
    selectedLevelClass() {
      if (!this.selectedInsight) return 'insight-icon-info'
      return `insight-icon-${this.selectedInsight.level || 'info'}`
    },
    selectedRecommendations() {
      if (!this.selectedInsight) return []

      if (this.selectedType === 'weather') {
        const m = this.selectedInsight.metrics || {}
        const lines = []

        if ((m.rainProb || 0) >= 70) {
          lines.push('Reprogramar aplicacao para janela com menor probabilidade de chuva.')
        }
        if ((m.wind || 0) >= 15 || (m.gust || 0) >= 25) {
          lines.push('Ajustar ponta, pressao e faixa de aplicacao para reduzir deriva.')
        }
        if ((m.temperature || 0) >= 30 && (m.humidity || 0) < 45) {
          lines.push('Priorizar aplicacao no inicio da manha ou fim da tarde.')
        }
        if (!lines.length) {
          lines.push('Manter plano de aplicacao com monitoramento de campo e calibracao ativa.')
        }
        return lines
      }

      if ((this.selectedInsight.level || '') === 'warning') {
        return [
          'Escalonar alerta para supervisao tecnica da regional.',
          'Revisar agenda de campo e priorizar produtores de maior risco.',
          'Revalidar criterio de aplicacao e janela operacional.',
        ]
      }

      if ((this.selectedInsight.level || '') === 'positive') {
        return [
          'Replicar a pratica nas demais regionais com perfil semelhante.',
          'Aproveitar o momento para ampliar cobertura comercial.',
          'Documentar o padrao para o playbook tecnico da safra.',
        ]
      }

      return [
        'Monitorar indicador diariamente para confirmar tendencia.',
        'Ajustar recomendacoes por tecnico e por cultura.',
        'Cruzar insight com dados de emissao para priorizacao.',
      ]
    },
  },
  methods: {
    iconByLevel(level) {
      if (level === 'warning') return 'alert-triangle'
      if (level === 'positive') return 'trending-up'
      return 'activity'
    },
    openInsightDetail(item, type) {
      this.selectedInsight = item
      this.selectedType = type
      this.$refs.detailModal.show()
    },
    tryAutoOpenWeatherModal() {
      if (this.hasAutoOpenedWeatherModal) {
        return
      }
      if (this.weatherLoading) {
        return
      }
      if (!this.weatherInsight) {
        return
      }
      this.hasAutoOpenedWeatherModal = true
      this.openInsightDetail(this.weatherInsight, 'weather')
    },
  },
}
</script>

<style scoped>
.executive-card {
  border: 1px solid #d8e5ec;
  border-radius: 16px;
  box-shadow: 0 10px 24px rgba(9, 32, 58, 0.08);
}

.section-header {
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f2b40;
}

.section-badge {
  border-radius: 999px;
  border: 1px solid #c8dae8;
  background: #f0f7fb;
  padding: 4px 10px;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 700;
  color: #2f5771;
}

.insight-card {
  border-radius: 14px;
  padding: 14px;
  border: 1px solid transparent;
  min-height: 118px;
  box-shadow: 0 8px 18px rgba(10, 30, 48, 0.06);
}

.insight-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 7px;
}

.insight-icon {
  width: 24px;
  height: 24px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.insight-card h6 {
  margin-bottom: 0;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.insight-card p {
  color: #2c4a5f;
  font-size: 13px;
}

.insight-source {
  display: block;
  margin-top: 8px;
  font-size: 11px;
  color: #4f6a7f;
}

.climate-card {
  min-height: auto;
}

.climate-metrics {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.climate-metrics span {
  font-size: 11px;
  font-weight: 700;
  color: #234a63;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(176, 200, 218, 0.7);
  border-radius: 999px;
  padding: 2px 8px;
}

.insight-detail-btn {
  margin-top: 10px;
  border: 1px solid #b9cede;
  background: #ffffff;
  color: #24516d;
  border-radius: 8px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 700;
}

.insight-detail-btn:hover {
  border-color: #0f5f7f;
  color: #0f5f7f;
}

.insight-modal-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.insight-modal-icon {
  width: 30px;
  height: 30px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.insight-modal-subtitle {
  color: #5a7387;
  font-size: 11px;
}

.insight-modal-text {
  color: #1f445d;
  font-size: 14px;
}

.insight-reco-box {
  border: 1px solid #d8e5ef;
  border-radius: 12px;
  background: #f8fcff;
  padding: 10px 12px;
}

.insight-reco-box h6 {
  margin-bottom: 8px;
  color: #1b415b;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.insight-reco-box ul {
  margin: 0;
  padding-left: 18px;
}

.insight-reco-box li {
  color: #30556d;
  font-size: 13px;
  margin-bottom: 4px;
}

.insight-warning {
  background: #fff5eb;
  border-color: #f8d7b5;
}

.insight-icon-warning {
  background: #ffe7cc;
  color: #a66224;
}

.insight-positive {
  background: #eaf8f0;
  border-color: #c5e8d5;
}

.insight-icon-positive {
  background: #d7f3e3;
  color: #117448;
}

.insight-info {
  background: #edf5ff;
  border-color: #cfe1f7;
}

.insight-icon-info {
  background: #dcecff;
  color: #24557a;
}

:deep(.insight-modal-content) {
  border-radius: 14px;
  border: 1px solid #d1e1ed;
}
</style>
